(function($) {
    class W4D_ProgressBar {
        constructor() {
            // Inicijalizacija selektora i podataka
            this.$progressContainer = $('.js-progress-container');
            this.$progressBar = $('.js-progress-bar');
            this.$progressText = $('.js-progress-text');

            if (this.isProgressBarAvailable()) {
                this.currentPrice = parseFloat(this.$progressContainer.data('current-price'));
                this.freeDeliveryAmount = parseFloat(this.$progressContainer.data('free-delivery'));

                // Inicijalno postavljanje trake napretka
                this.initProgressBar(this.calculatePercentage(this.currentPrice, this.freeDeliveryAmount));
            }

            this.bindEvents();
        }

        isProgressBarAvailable() {
            return this.$progressContainer.length && this.$progressBar.length && this.$progressText.length;
        }

        bindEvents() {
            $(window).on('resize', () => {
                if (this.isProgressBarAvailable()) {
                    this.initProgressBar(this.calculatePercentage(this.currentPrice, this.freeDeliveryAmount));
                }
            });
        }

        updateProgressAfterCartChange(currentPrice) {
            if (!this.isProgressBarAvailable()) return;
            if (currentPrice !== undefined) {
                this.$progressContainer.data('current-price', currentPrice).attr('data-current-price', currentPrice);
                this.currentPrice = currentPrice;
            } else {
                this.currentPrice = this.$progressContainer.data('current-price');
            }

            const freeDeliveryAmount = this.$progressContainer.data('free-delivery');
            const percentage = this.calculatePercentage(this.currentPrice, freeDeliveryAmount);

            // Izračunaj preostali iznos
            const currentAmount = this.parsePrice(this.currentPrice);
            const freeDeliveryValue = this.parsePrice(freeDeliveryAmount);
            const remainingAmount = (freeDeliveryValue - currentAmount).toFixed(2);

            // Ažuriraj tekst
            if (percentage < 100) {
                this.$progressText.html(`Još samo <strong><span class="woocommerce-Price-amount amount"><bdi>${remainingAmount.replace('.', ',')}&nbsp;<span class="woocommerce-Price-currencySymbol">€</span></bdi></span></strong> do besplatne dostave`);
            } else {
                this.$progressText.html('<strong>Ostvarili ste besplatnu dostavu</strong>');
            }

            this.initProgressBar(percentage);
        }

        calculatePercentage(currentPrice, freeDeliveryAmount) {
            const currentAmount = this.parsePrice(currentPrice);
            const targetAmount = this.parsePrice(freeDeliveryAmount);

            const percentage = (currentAmount / targetAmount) * 100;
            return Math.min(percentage, 100).toFixed(2);
        }

        parsePrice(price) {
            price = typeof price === 'string' ? price : String(price);
            return parseFloat(price.replace(',', '.'));
        }

        initProgressBar(percentage) {
            if (!this.isProgressBarAvailable()) {
                console.warn('Progress bar elements are missing on this page.');
                return;
            }

            const progressPercent = Math.min(percentage, 100);
            this.$progressBar.css('width', `${progressPercent}%`);

            if (progressPercent >= 100) {
                this.$progressBar.addClass('progress-bar--completed');
            } else {
                this.$progressBar.removeClass('progress-bar--completed');
            }

            // Izračunaj poziciju teksta
            const progressContainerWidth = this.$progressContainer.width();
            const calculatedProgressBarWidth = (progressPercent / 100) * progressContainerWidth;
            const textWidth = this.$progressText.width();

            // Postavi klase za pozicioniranje teksta
            if (textWidth > calculatedProgressBarWidth) {
                this.$progressText.addClass('outside-right').removeClass('inside-left');
            } else {
                this.$progressText.addClass('inside-left').removeClass('outside-right');
            }
        }
    }

    // Inicijaliziraj i postavi globalnu instancu
    $(document).ready(() => {
        window.W4D_ProgressBar = new W4D_ProgressBar();
    });

})(jQuery);